var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBasketFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_18273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.56897V10.469H0.9785L2.185 18.069H16.8245L18.031 10.469H19.0095V8.56897H0ZM5.396 16.986H3.2395V10.507H5.396V16.986ZM8.854 16.986H6.6975V10.507H8.854V16.986ZM12.312 16.986H10.1555V10.507H12.312V16.986ZM15.77 16.986H13.6135V10.507H15.77V16.986Z",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26816 7.087L4.60766 2.5935H5.17766V3.458H13.8227V2.5935H14.3927L15.7322 7.087H17.5277L15.6847 0.8645H13.8227V0H5.17766V0.8645H3.31566L1.47266 7.087H3.26816Z",
    fill: "#444444"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_18273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 18.069,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasketFill);
export default __webpack_public_path__ + "static/media/icon_basket_fill.e0aaeadad8d9efab4a93a4640375afcb.svg";
export { ForwardRef as ReactComponent };